import { Role } from './Role'
import { type IamApi } from '@/features/iam/api/iam-api'
import { collection } from '@/infra/collection'
import { Id } from '@/infra/id'
import { mapRoleResourceToProps } from './role-mappers'
import type { RoleProps } from './Role'

export interface ListRolesQuery {
  workspaceId: Id
}

export type PrimeRoleFn = (props: Partial<RoleProps>) => Role | undefined

export class RoleStore {
  readonly roles = collection({
    getDataId: (data) => data.id,
    getModelId: (model) => model.id,
    create: () => new Role(),
  })

  constructor(private readonly _api: IamApi) {}

  forWorkspace(workspaceId: Id) {
    const id = Id.assert(workspaceId)
    return this.roles.filter((x) => Id.assert(x.workspaceId) === id)
  }

  async fetchRoles(query: ListRolesQuery, signal?: AbortSignal) {
    return this._api.roles
      .list({ workspace_id: Id.assert(query.workspaceId) }, signal)
      .then((data) => this.roles.set(data.map(mapRoleResourceToProps)))
  }
}
